import { render } from "./SIDetailPage.vue?vue&type=template&id=4f1f019e&scoped=true"
import script from "./SIDetailPage.vue?vue&type=script&lang=js"
export * from "./SIDetailPage.vue?vue&type=script&lang=js"

import "./SIDetailPage.vue?vue&type=style&index=0&id=4f1f019e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f1f019e"

export default script